export enum AceOpportunityOwnerEnum {
  AWS = 'AWS Referral',
  PARTNER = 'Partner Referral',
}
